/**
 * Coups de pouce — Attendu 615 « Résoudre des problèmes de multiplication décimale ».
 * Une entrée par generator_key (cf. gen_615.js).
 */

// ── Un même prix répété = une multiplication : animation (id cp615play1) ──
// Exemple hors pools : un carnet à 2,30 €, 4 carnets → 4 × 2,30 = 9,20 €.
const SVG_PROBMULT_ANIM = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 360 204" role="img"
     aria-label="Un carnet coûte 2,30 euros. Combien coûtent 4 carnets ? Le même prix se répète 4 fois : 2,30 plus 2,30 plus 2,30 plus 2,30, c'est la multiplication 4 fois 2,30, qui vaut 9,20 euros.">
  <g id="cp615play1" style="cursor:pointer">
    <title>Lancer l'animation</title>
    <rect x="266" y="4" width="86" height="24" rx="12" fill="#1E3A8A"/>
    <path d="M278 10 L278 22 L288 16 Z" fill="#ffffff"/>
    <text x="322" y="20" font-size="12" font-weight="600" fill="#ffffff" text-anchor="middle" font-family="system-ui,sans-serif">Lancer</text>
  </g>
  <!-- l'énoncé -->
  <text x="20" y="50" font-size="13" font-weight="600" fill="#64748b" font-family="system-ui,sans-serif" opacity="0">Un carnet coûte 2,30 €. Combien coûtent 4 carnets ?<animate attributeName="opacity" values="0;0" dur="0.05s" begin="cp615play1.click" fill="freeze"/><animate attributeName="opacity" values="0;1" dur="0.3s" begin="cp615play1.click+0.3s" fill="freeze"/></text>
  <!-- le même prix répété -->
  <g font-size="14" font-weight="700" fill="#0f172a" font-family="system-ui,sans-serif" text-anchor="middle" opacity="0">
    <text x="180" y="86">2,30 + 2,30 + 2,30 + 2,30</text>
    <animate attributeName="opacity" values="0;0" dur="0.05s" begin="cp615play1.click" fill="freeze"/>
    <animate attributeName="opacity" values="0;1" dur="0.3s" begin="cp615play1.click+1.6s" fill="freeze"/>
  </g>
  <text x="180" y="104" font-size="11" font-weight="700" fill="#1D9E75" text-anchor="middle" font-family="system-ui,sans-serif" opacity="0">le même prix, 4 fois<animate attributeName="opacity" values="0;0" dur="0.05s" begin="cp615play1.click" fill="freeze"/><animate attributeName="opacity" values="0;1" dur="0.3s" begin="cp615play1.click+2.4s" fill="freeze"/></text>
  <!-- repli en multiplication -->
  <g opacity="0">
    <path d="M180,112 L180,126" stroke="#1D9E75" stroke-width="1.8"/>
    <text x="180" y="146" font-size="18" font-weight="700" fill="#1D9E75" text-anchor="middle" font-family="system-ui,sans-serif">4 × 2,30 = 9,20 €</text>
    <animate attributeName="opacity" values="0;0" dur="0.05s" begin="cp615play1.click" fill="freeze"/>
    <animate attributeName="opacity" values="0;1" dur="0.3s" begin="cp615play1.click+3.6s" fill="freeze"/>
  </g>
  <!-- conclusions -->
  <g opacity="0">
    <rect x="20" y="188" width="8" height="8" rx="2" fill="#1E3A8A"/>
    <text x="36" y="196" font-size="13" font-weight="600" fill="#0f172a" font-family="system-ui,sans-serif">Un même prix répété : c'est une multiplication.</text>
    <animate attributeName="opacity" values="0;0" dur="0.05s" begin="cp615play1.click" fill="freeze"/>
    <animate attributeName="opacity" values="0;1" dur="0.3s" begin="cp615play1.click+6.2s" fill="freeze"/>
  </g>
</svg>`.trim();

const CP_PROBMULT_615 = {
    pages: [
        {
            titre: 'La méthode',
            svg: SVG_PROBMULT_ANIM,
        },
    ],
};

const CP_615 = {
    probmult_qcm_unique: CP_PROBMULT_615,
    // Entrée partagée : même méthode (repérer la répétition → multiplier →
    // contrôler par ordre de grandeur).
    probmult_texte: CP_PROBMULT_615,
};

export default CP_615;
